import type { SignupFormData } from '../api/types'
import { saveSignupDataToCookie } from './signup-data-cookie'

/**
 * "Complete seus dados" step of the entity-notice fake-door signup (cells
 * A/B): persists the form into the same `signup_data` cookie the standalone
 * CPF-based signup page relies on, in-modal, with no redirect — the CPF
 * finalize step's `completeSignupWithCpf` request reads it server-side.
 */
export function saveEntityNoticeCompleteData(data: SignupFormData): void {
  saveSignupDataToCookie({
    name: data.fullName,
    password: data.password,
    occupation: data.occupation,
  })
}
